import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "How often should I clean my windows?",
      answer: "Clean windows do more than sparkle — they brighten your home, protect the glass, and create a space that feels cared for. For most residential homes, we recommend a full professional cleaning at least once a year to clear away dirt, pollen, insects, and the minerals that can cause permanent water stains. Many families prefer twice-yearly exterior cleanings (spring and fall) so their home always looks welcoming and well-maintained. And if your home is near the ocean, we suggest bi-weekly exterior cleanings to stay ahead of salt spray and buildup, which can damage glass if left too long. When it comes to businesses — like restaurants, storefronts, and car showrooms — clean windows matter even more. Many of our commercial clients schedule monthly, bi-weekly, or even weekly cleanings so their property always makes the best impression."
    },
    {
      question: "What is Soft Washing?",
      answer: "Think of soft washing as the gentle touch your property deserves. Instead of blasting with harsh pressure that can strip paint, crack siding, or damage shingles, we use a low-pressure system combined with safe, eco-friendly cleaning solutions. This gently removes dirt, algae, mildew, and stains, then rinses everything away with fresh water — leaving your home or business looking refreshed without ever putting it at risk. For residential homes, it's the perfect way to bring siding, cedar, fences, and roofs back to life. For businesses — from storefronts and restaurants to car showrooms, parking lots, and gas stations — soft washing keeps exteriors looking spotless and inviting."
    },
    {
      question: "How often should I wash my home's exterior and roof?",
      answer: "Your home's exterior and roof are exposed to sun, rain, salty air, and humidity year-round. Over time, that means dirt, algae, mildew, and black streaks will build up. On average, most homeowners wash their exteriors every 2–3 years, but many choose every 1–2 years to keep their siding, paint, and surfaces looking fresh. For the best protection, we recommend at least an annual wash. Your roof needs the same care. A professional roof cleaning every 1–2 years removes moss, lichen, algae, and black streaks before they can stain or shorten the lifespan of shingles. For businesses, regular exterior washing isn't just about curb appeal, it's also about liability and safety."
    },
    {
      question: "How long does a cleaning take?",
      answer: "Every property is different, but we'll always let you know exactly what to expect before we begin. For window cleaning, a good rule of thumb is about 10 minutes per window when we're doing both the interior and exterior. On most homes, that adds up to around 4–6 hours of detailed cleaning, depending on the number of windows. A full house wash or roof cleaning usually takes about 4–6 hours as well, while larger properties may take a bit longer. For gutter cleaning, most homes take 2–4 hours. When you request a quote, just let us know exactly what you'd like cleaned, and we'll give you a clear estimate for both time and cost — no surprises, no hidden fees."
    },
    {
      question: "Do you wear shoe covers when inside my house?",
      answer: "Absolutely. Respecting your home is part of who we are. Whenever we step inside — whether you have hardwood, tile, or carpet — we put on fresh shoe covers so we never track in dirt or risk scuffing your floors. It may seem like a small detail, but it reflects how we work: with thoughtfulness, care, and respect."
    },
    {
      question: "What if I am not happy with my cleaning?",
      answer: "We stand behind every job with a 100% satisfaction guarantee. If something isn't right, just let us know within 24 hours of service and we'll come back right away to make it right — whether that means touching up a spot or re-cleaning the entire area. And here's our promise: if you're still not happy after that, you don't pay. It's that simple."
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our services
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-xl px-6 hover:shadow-md transition-shadow duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-lg text-gray-900 hover:text-blue-600 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
